import axios from "axios";
import jwtDecode from "jwt-decode";
import React, { useEffect, useState, Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import Loading from "./components/Loading";
import Unauthorized from "./components/Unauthorized";
import { isEmptyObject } from "./helpers/ObjectHelper";
import useAuth from "./hooks/useAuth";

// Lazy load layout components for code splitting
const Admin = lazy(() => import("./layouts/Admin"));
const Auth = lazy(() => import("./layouts/Auth"));
const HomePage = lazy(() => import("./layouts/HomePage"));
const User = lazy(() => import("./layouts/User"));

function App() {
  const { auth, setAuth } = useAuth();
  const [loginData, setLoginData] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    try {
      if (isEmptyObject(auth)) {
        axios
          .get(`${window._HOST}/api/v1/token`, { withCredentials: true })
          .then((response) => {
            setLoginData(response);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    } catch (error) {
      console.log(error);
    }
  }, [auth]);

  useEffect(() => {
    if (loginData !== null) {
      const decoded = jwtDecode(loginData.data.accessToken);
      setAuth({
        id_user: decoded.userId,
        id_role: decoded.role,
        email: decoded.email,
        nama_user: decoded.name,
        role: decoded.role,
        list_feature: decoded.userFeature,
      });
    }
    const loadingTimeout = setTimeout(() => {
      setIsLoading(false);
    }, 750);

    return () => {
      clearTimeout(loadingTimeout);
    };
  }, [loginData, setAuth]);

  if (isLoading === true) {
    return <Loading />;
  }

  return (
    <Suspense fallback={<Loading />}>
      <Routes>
        <Route path="/*" element={<HomePage />} />
        <Route path="auth/*" element={<Auth />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route path="admin/*" element={<Admin />} />
        <Route path="user/*" element={<User />} />
      </Routes>
    </Suspense>
  );
}

export default App;
